import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import './style.css'
import Navbar from '../common/Navbar'
import { handleLoginSubmit, handleValidateLogin } from '../../services/LoginService';
import { fetchData } from '../../services/HomeService';
import { Helmet } from "react-helmet";
import LoginBox from './LoginFormComponent';
import SelectingUser from '../user/SelectionComponent';
import { BASE_IMG, DEFAULT_REDIRECT_ROUTE, BRAND_NAME, LOGIN_LOGO_IMG, BRAND_TAGLINE, LOGIN_TITLE_IMG } from '../../constants';
import { showErrorMessage, showLoader, showSuccessMessage } from '../../utils';

export default function LoginComponent() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [failedLocalLoginAttempts, setFailedLocalLoginAttempts] = useState(0);
    const [allValues, setAllValues]  = useState({
        orgType: '',
        verified: false,
        displayType: 'login',
        step: 'email',
    })

    const handleLogin = async (e, authType, username, password) => {
        if (authType === 'local' && (!username || !password)) {
            showErrorMessage('Enter email and password');
            return;
        }
        setIsLoading(true);
        const { success, data={} , message='' } = await handleLoginSubmit(e, authType, username, password);
        if (success) {
            if (authType === 'local') {
                setFailedLocalLoginAttempts(0);
            }
            navigate(`${DEFAULT_REDIRECT_ROUTE}?${new URLSearchParams(data).toString()}`);
            showSuccessMessage(data.message || 'Logged in successfully');
        } else {
            if (authType === 'local') {
                setFailedLocalLoginAttempts((prevCount) => prevCount + 1);
            }
            showErrorMessage(message || 'Invalid email or password');
        }
        setIsLoading(false);
    }

    const location = useLocation();

    useEffect(() => {
        const checkSessionAndSkipLogin = async () => {
            const resp = await fetchData('/users/session/status');
            if (resp?.success) {
                const { success, data: { verified= false, org_type= '', step= 'email' } } = await handleValidateLogin();
                if (success) {
                    const params = new URLSearchParams({
                        step: step,
                        org_type: org_type,
                        verified: verified,
                    });
                    if (org_type && verified && step) {
                        navigate(`${DEFAULT_REDIRECT_ROUTE}?${params.toString()}`);
                    } else {
                        setAllValues({
                            ...allValues,
                            displayType: 'selection',
                            orgType: org_type,
                            verified: verified,
                            step: step,
                        })
                    }
                }
            }
        };
        checkSessionAndSkipLogin();
    }, [navigate]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        setAllValues({
            ...allValues, 
            step: queryParams.get('step'),
            orgType: queryParams.get('org_type'), 
            verified: queryParams.get('verified'),
            displayType: queryParams.get('type'), 
        })
    }, []);

    return (<>
        <Helmet>
            <title>{BRAND_NAME} - Login</title>
            <meta name="description" content={`Securely log in to your ${BRAND_NAME} account for personalized access and exclusive features. Streamline your interactions and manage your profile effortlessly`} />
            <link rel="canonical" href="/login" />
        </Helmet>

        <div>
            <div className="login">
                <div className="left-container">
                    <img src={`${BASE_IMG}/login_left.svg`} height="95%" width="95%" />
                </div>
                <div className="right-container">
                    <div className='right-subContainer'>
                        <div className="app-title-logo">
                            <div className="app-logo">
                                <img src={LOGIN_LOGO_IMG} alt="Logo" height="100%" width="100%" />
                            </div>
                            {LOGIN_TITLE_IMG ? (
                                <div className="app-title">
                                    <img src={LOGIN_TITLE_IMG} alt="Title" />
                            </div>
                            ) : null}
                        </div>
                        <div className="app-motto-text">{BRAND_TAGLINE}</div>
                        {allValues.displayType === 'selection' ? (
                            <SelectingUser orgType={allValues.orgType} verified={allValues.verified} step={allValues.step}/>
                        ) : (
                            <LoginBox
                                handleLogin={handleLogin}
                                showForgotPassword={failedLocalLoginAttempts > 0}
                            />
                        )}

                        <p className="login-bottom-text-container-bottom">&copy; Copyright 2026 RazeHQ. All rights reserved.</p>
                    </div>
                </div>
            </div>
            <Navbar showSettings={false} />
            {isLoading && showLoader("Logging")} 
        </div>
    </>
    );
}

